import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import { ResponseDeleteDto, ResponseSaveDto, ResponseAddDto, ResponseTypeDto, ResponseHistoryDto, ResponseHistoryByIdDto } from '../dto/letter.dto';

@Injectable()
export class LetterSf6Api {

  private readonly service: string = '';
  private readonly model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public type(): Observable<ResponseTypeDto> {
    const method: string = 'GET';
    const func: string = 'letter/type';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, func, params, body);
  }

  public historyById(requestNo: string): Observable<ResponseHistoryByIdDto> {
    const method: string = 'GET';
    const func: string = 'letter/historyById';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryByIdDto>(method, url, func, params, body);
  }

  public history(empId: string, limit: string | number, skip: string | number): Observable<ResponseHistoryDto> {
    const method: string = 'GET';
    const func: string = 'letter/history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public add(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'letter/add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'letter/save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public delete(payload: any): Observable<ResponseDeleteDto> {
    const method: string = 'POST';
    const func: string = 'letter/delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDto>(method, url, params, urlParams, body);
  }

  public listing(empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'letter/listing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  downloadPdf(data){
    const method: string = 'POST';
    const func: string = 'letter/downloadPdf';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams,body)
}

  previewLetter(letterNo: string) {
    const method: string = 'GET';
    const func: string = 'letter/previewLetter';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof letterNo !== 'undefined' && letterNo !== null) urlParams.letterNo = letterNo;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  previewLetterNew(letterNo: string) {
    const method: string = 'POST';
    const func: string = 'letter/previewLetterNew';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof letterNo !== 'undefined' && letterNo !== null) params.letterNo = letterNo;
    
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams,body)
  }

  downloadPDFLetter() {
    const method: string = 'POST';
    const func: string = 'letter/downloadPDFLetter';
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/letter.api.ts